import React from 'react';
import './Dashboard.css';
import { useNavigate } from 'react-router-dom';
import { FiClipboard, FiClock, FiBarChart2, FiTrendingUp } from 'react-icons/fi'; // or other icons

function QuickSummary({ onProgressClick }) {
    const navigate = useNavigate();
    const summaryData = [
        {
            title: 'Tests Given',
            value: 12,
            icon: <FiClipboard />,
            color: '#e3f2fd', // light blue tint
            onClick: () => navigate('/my-tests')
        },
        // {
        //     title: 'Upcoming Exams',
        //     value: 3,
        //     icon: <FiClock />,
        //     color: '#fff3e0',
        //      // light orange tint
        // },
        {
            title: 'Average Score',
            value: '78%',
            icon: <FiBarChart2 />,
            color: '#ede7f6', // light purple tint
        },
        {
            title: 'Progress Level',
            value: '65%',
            icon: <FiTrendingUp />,
            color: '#e8f5e9', // light green tint
            onClick: onProgressClick, // 👈 Scroll to performance chart
        },
    ];

    return (
        <div className="summary-cards-container">
            {summaryData.map((card, index) => (
                <div key={index} className="summary-card"
                    onClick={card.onClick}
                    style={{ backgroundColor: card.color }}>
                    <div className="summary-icon">{card.icon}</div>
                    <div className="summary-content">
                        <p className="summary-title">{card.title}</p>
                        <p className="summary-value">{card.value}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default QuickSummary;
